"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumericMaxValidation = void 0;
var ValidationMethodBase_1 = require("./ValidationMethodBase");
var journey_model_1 = require("@athena-portal/journey-model");
var NumericMaxValidation = exports.NumericMaxValidation = /** @class */ (function (_super) {
    __extends(NumericMaxValidation, _super);
    function NumericMaxValidation(props, commandsExecutor) {
        var _this = _super.call(this, commandsExecutor) || this;
        _this.props = props;
        if ((!_this.props.maxValue && _this.props.maxValue !== 0) || isNaN(_this.props.maxValue)) {
            throw Error("Missing setting: maxValue");
        }
        return _this;
    }
    NumericMaxValidation.prototype.validateInput = function (input, context) {
        var inputAsNumber = Number.parseFloat(input);
        if (isNaN(inputAsNumber) && input) {
            var error = this.getErrorMessage(context, "".concat(context.fieldName, " should be number"));
            return this.invalidResult(error);
        }
        if (!isNaN(inputAsNumber) && inputAsNumber > this.props.maxValue) {
            var error = this.getErrorMessage(context, "".concat(context.fieldName, " should be smaller or equal to ").concat(this.props.maxValue));
            return this.invalidResult(error);
        }
        return this.validResult();
    };
    NumericMaxValidation = __decorate([
        (0, journey_model_1.settings)([
            { name: "maxValue", type: journey_model_1.TypeDescriptions.Number },
        ]),
        __metadata("design:paramtypes", [Object, Object])
    ], NumericMaxValidation);
    return NumericMaxValidation;
}(ValidationMethodBase_1.ValidationMethodBase));
//# sourceMappingURL=NumericMaxValidation.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/journey-services/dist/validations/NumericMaxValidation.js
// module id = 2099
// module chunks = 0